import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Navbar from "scenes/navbar";
import Sidebar from "scenes/sidebar";
import ChatWidget from "components/chat/ChatWidget";
import AICopilotPanel from "components/ai/AICopilotPanel";


const Layout = () => {
  const location = useLocation();
  const user = useSelector((state) => state.user);         
  const isAuthenticated = user && Object.keys(user).length > 0;
  const sidebarState = useSelector((state) => state.isSidebarOpen);
  
  const [isSidebarOpen] = useState(sidebarState || false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return (
    <Box display="flex">
      <Sidebar
        isSidebarOpen={isSidebarOpen}        
        isMobileOpen={isMobileOpen}
        onClose={() => setIsMobileOpen(false)}
      />
      <Box flexGrow={1}>
        <Navbar onMobileMenuOpen={() => setIsMobileOpen(true)} />
        <Outlet />
      </Box>
      <ChatWidget />
      <AICopilotPanel />
    </Box>
  )
};

export default Layout;